module.exports = __webpack_public_path__ + "img/LOADING.c1789d5c.gif";